import { fillTemplate, useHomeStrings } from '../../../i18n'

export default function HowToCompress() {
  const t = useHomeStrings().howTo

  return (
    <div className="px-4" id="how-to-compress-glb">
      <div className="lg:text-center mb-12">
        <h2 className="text-3xl leading-8 font-extrabold tracking-tight text-foreground sm:text-4xl">
          {t.heading}
        </h2>
        <p className="mt-4 max-w-2xl text-xl text-muted-foreground/90 lg:mx-auto">
          {t.lead}
        </p>
      </div>

      <ol className="grid gap-6 md:grid-cols-3">
        {t.steps.map((step, index) => (
          <li key={step.name} className="p-6 bg-background-elevated rounded-xl border border-border/60 shadow-sm">
            <span className="flex items-center justify-center h-10 w-10 rounded-lg bg-primary text-primary-foreground font-bold">
              {index + 1}
            </span>
            <h3 className="mt-4 text-lg font-semibold text-foreground">{step.name}</h3>
            <p className="mt-2 text-muted-foreground/90 text-sm">{step.description}</p>
          </li>
        ))}
      </ol>

      <div className="mt-12 max-w-3xl mx-auto">
        <h3 className="text-xl font-semibold text-foreground">{t.whatHappensHeading}</h3>
        <ul className="mt-4 space-y-3 text-muted-foreground/90">
          {t.items.map((item) => (
            <li key={item.title}>
              <strong className="text-foreground">{item.title}</strong> {fillTemplate(item.text, item.links)}
            </li>
          ))}
        </ul>
        <p className="mt-6 text-muted-foreground/90">
          {fillTemplate(t.footer.text, t.footer.links)}
        </p>
      </div>
    </div>
  )
}
